import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Mermaid"] */ "/vercel/path0/src/components/blog/mermaid/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SandpackWrapper","CodeSandbox"] */ "/vercel/path0/src/components/code/sandpack/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CopyButton"] */ "/vercel/path0/src/components/copy-button/index.tsx");
